// src/components/ProjectStatus.js
import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { getProjects } from "../../services/api"; // Funciones para obtener y actualizar el proyecto

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const ProjectStatus = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await getProjects();
        if (response) {
          setProjects(response);
        } else {
          setProjects([]);
        }
      } catch (error) {
        setError("Error al obtener proyectos");
        console.error("Error al obtener proyectos", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const getStatusCounts = () => {
    const statusCounts = {};
    projects.forEach((project) => {
      statusCounts[project.status] = (statusCounts[project.status] || 0) + 1;
    });
    return statusCounts;
  };

  const statusCounts = getStatusCounts();
  const data = {
    labels: Object.keys(statusCounts),
    datasets: [
      {
        label: "Número de Proyectos por Estado",
        data: Object.values(statusCounts),
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  if (loading) {
    return <p>Cargando...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <>
      <h3>Estado de los Proyectos</h3>
      <Bar data={data} options={{ responsive: true }} />
    </>
  );
};

export default ProjectStatus;
